export const CHANGE_THEME = "CHANGE_THEME";
export const DARK = "dark";
export const LIGHT = "light";
export const THEME = "theme";
